<div class="phx-table-cell-custom-text-content">
  <div class="phx-table-cell-custom-prefix-area">
    <ng-content select="[phx-custom-cell-prefix-icon]"></ng-content>
  </div>
  <div class="phx-table-cell-custom-primary-area">
    <ng-content select="[phx-custom-cell-primary]"></ng-content>
  </div>
  <div class="phx-table-cell-custom-secondary-area">
    <ng-content select="[phx-custom-cell-secondary]"></ng-content>
  </div>
  <div class="phx-table-cell-custom-tertiary-area">
    <ng-content select="[phx-custom-cell-tertiary]"></ng-content>
  </div>
  <div class="phx-table-cell-custom-inline-icon-area">
    <ng-content select="[phx-custom-cell-inline-icon]"></ng-content>
  </div>
  <div class="phx-table-cell-custom-tag-area">
    <ng-content select="[phx-custom-cell-tag]"></ng-content>
  </div>
</div>
